export default {
	path: 'settings',
	name: 'Settings',
	component: () => import('@/views/settings/Index'),
	redirect: { name: 'SettingsFeatures' },
	meta: {
		title: 'Settings',
	},
	children: [
		{
			path: 'features',
			name: 'SettingsFeatures',
			component: () => import('@/views/settings/Features'),
			meta: {
				title: 'Features',
			},
		},
		{
			path: 'styles',
			name: 'SettingsStyle',
			component: () => import('@/views/settings/Style'),
			meta: {
				title: 'Styles',
			},
		},
		{
			path: 'projects',
			name: 'SettingsProjects',
			component: () => import('@/views/settings/Projects'),
			meta: {
				title: 'Projects',
			},
		},
		{
			path: 'users',
			name: 'SettingsUsers',
			component: () => import('@/views/settings/Users'),
			meta: {
				title: 'Users',
			},
		},
		// {
		// 	path: 'plan',
		// 	name: 'SettingsPlan',
		// 	component: () => import('@/views/settings/Plan'),
		// 	meta: {
		// 		title: 'Plan',
		// 	},
		// },
		// {
		// 	path: 'security',
		// 	name: 'SettingsSecurity',
		// 	component: () => import('@/views/settings/Security'),
		// 	meta: {
		// 		title: 'Security',
		// 	},
		// },
	],
};
